/* ==========================================================================
   Finding Wonderland — theme behaviour (vanilla, no dependencies)
   Cart drawer · mega-menu hover previews · product gallery + lightbox
   Newsletter popup + minimised pill · sparkle hover sound · quantity steppers
   Reads settings from window.FWSettings (rendered by snippets/fw-settings.liquid)
   ========================================================================== */
(function () {
  'use strict';
  if (window.__fwBooted) return; /* the script can be included by several sections — run once */
  window.__fwBooted = true;

  var S = window.FWSettings || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return (S.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v);
  };

  /* ---------------------------------------------------------------- sparkle */
  var Sparkle = {
    ctx: null,
    init: function () {
      if (S.sound === false) return;
      var unlock = function () {
        var C = window.AudioContext || window.webkitAudioContext;
        if (!C) return;
        if (!Sparkle.ctx) Sparkle.ctx = new C();
        if (Sparkle.ctx.state === 'suspended') Sparkle.ctx.resume();
      };
      ['pointerdown','touchstart','keydown','click'].forEach(function (ev) { window.addEventListener(ev, unlock, true); });

      var last = null, lastAt = 0;
      document.addEventListener('mouseover', function (e) {
        var hot = Sparkle.hotspot(e.target);
        if (!hot || hot === last) return;
        last = hot;
        var now = Date.now();
        if (now - lastAt < 90) return;
        lastAt = now;
        Sparkle.play();
      });
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget || !last || !last.contains(e.relatedTarget)) last = null;
      });
    },
    hotspot: function (node) {
      var el = node, hops = 0;
      while (el && el !== document.body && hops < 7) {
        if (el.matches && el.matches('a,button,[role="button"],select,summary')) return el;
        var c = getComputedStyle(el).cursor;
        if (c === 'pointer' || c === 'zoom-in') return el;
        el = el.parentElement; hops++;
      }
      return null;
    },
    play: function () {
      if (window.__fwMuted) return;
      var C = window.AudioContext || window.webkitAudioContext;
      if (!Sparkle.ctx && C) Sparkle.ctx = new C();
      var ac = Sparkle.ctx;
      if (!ac) return;
      if (ac.state === 'suspended') { ac.resume(); return; }
      var now = ac.currentTime;
      /* music box: a velvet low-pass and a soft echo, built once */
      if (!Sparkle.fx) {
        var master = ac.createGain(); master.gain.value = 0.55;
        var velvet = ac.createBiquadFilter(); velvet.type = 'lowpass'; velvet.frequency.value = 3200; velvet.Q.value = 0.3;
        var delay = ac.createDelay(1); delay.delayTime.value = 0.23;
        var fb = ac.createGain(); fb.gain.value = 0.32;
        var wet = ac.createGain(); wet.gain.value = 0.38;
        velvet.connect(master); velvet.connect(delay); delay.connect(fb); fb.connect(delay); delay.connect(wet); wet.connect(master);
        master.connect(ac.destination);
        Sparkle.fx = velvet;
      }
      var scale = [1047, 1175, 1319, 1568, 1760, 2093];
      Sparkle.step = ((Sparkle.step || 0) + (Math.random() < 0.5 ? 1 : 2)) % scale.length;
      var root = scale[Sparkle.step];
      [[root, 0, 0.011], [root * 1.5, 0.07, 0.005]].forEach(function (n) {
        var at = now + n[1];
        var g = ac.createGain();
        g.gain.setValueAtTime(0.0001, at);
        g.gain.exponentialRampToValueAtTime(n[2], at + 0.018);
        g.gain.exponentialRampToValueAtTime(0.0001, at + 1.1);
        g.connect(Sparkle.fx);
        [-4, 4].forEach(function (cents) {
          var o = ac.createOscillator(); o.type = 'sine';
          o.frequency.setValueAtTime(n[0], at); o.detune.setValueAtTime(cents, at);
          o.connect(g); o.start(at); o.stop(at + 1.15);
        });
      });
    }
  };

  /* ------------------------------------------------------------- mega menu */
  function initMega() {
    /* delegated, so it still works if the header is re-rendered or duplicated */
    var panelFor = function (t) { var h = t.closest('.fw-header') || document; return $('[data-fw-mega]', h); };
    var setOpen = function (t, open) { var p = panelFor(t); if (!p) return; p.classList.toggle('is-open', open); t.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    if (!window.__fwMegaBound) {
      window.__fwMegaBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-fw-mega-toggle]');
        if (t) { e.preventDefault(); e.stopPropagation(); var p = panelFor(t); setOpen(t, !(p && p.classList.contains('is-open'))); return; }
        if (!e.target.closest('[data-fw-mega]')) $('[data-fw-mega-toggle][aria-expanded="true"]').forEach(function (b) { setOpen(b, false); });
      }, true);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') $('[data-fw-mega-toggle]').forEach(function (b) { setOpen(b, false); });
      });
    }
    var toggle = $('[data-fw-mega-toggle]');
    var panel  = $('[data-fw-mega]');
    if (!toggle || !panel) return;

    /* hover previews — each link carries a JSON pool of products */
    var art   = $('[data-fw-peek-art]', panel);
    var label = $('[data-fw-peek-label]', panel);
    var title = $('[data-fw-peek-title]', panel);
    var blurb = $('[data-fw-peek-blurb]', panel);
    var cta   = $('[data-fw-peek-cta]', panel);
    if (!art) return;
    var fallback = { label: art.dataset.fwPeekArt, url: cta ? cta.getAttribute('href') : '#' };

    $$('[data-fw-peek]', panel).forEach(function (link) {
      var handler = function () {
        var pool;
        try { pool = JSON.parse(link.getAttribute('data-fw-peek')); } catch (err) { return; }
        if (!pool || !pool.length) return;
        var pick = pool[Math.floor(Math.random() * pool.length)];
        art.style.backgroundImage = 'url(' + pick.image + ')';
        if (label) label.textContent = link.dataset.fwPeekLabel || link.textContent.trim();
        if (title) title.textContent = pick.title;
        if (blurb) blurb.textContent = pick.subtitle || '';
        if (cta)   cta.setAttribute('href', pick.url);
        art.style.animation = 'none';
        void art.offsetWidth;
        art.style.animation = 'fw-rise 300ms cubic-bezier(.34,1.56,.64,1) both';
      };
      link.addEventListener('mouseenter', handler);
      link.addEventListener('focus', handler);
    });
  }

  /* --------------------------------------------------- product gallery/zoom */
  function initGallery() {
    var stage = $('[data-fw-stage]');
    if (!stage) return;
    var img = $('img', stage);

    $$('[data-fw-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-fw-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        img.src = btn.dataset.fwThumb;
        img.srcset = '';
      });
    });

    var box = $('[data-fw-lightbox]');
    if (!box) return;
    var full = $('img', box);
    var frame = $('.fw-lightbox__frame', box);
    var pill = $('[data-fw-lightbox-title]', box);
    var open = function () {
      full.src = img.src;
      if (frame) frame.classList.toggle('fw-lightbox__frame--bleed', stage.hasAttribute('data-fw-bleed'));
      if (pill && stage.dataset.fwTitle) pill.textContent = stage.dataset.fwTitle;
      box.classList.add('is-open'); document.body.style.overflow = 'hidden';
    };
    var shut = function () { box.classList.remove('is-open'); document.body.style.overflow = ''; };
    stage.addEventListener('click', open);
    box.addEventListener('click', function (e) { if (e.target === box || e.target.matches('[data-fw-close]')) shut(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* --------------------------------------------------------- qty + variants */
  function initQty() {
    $$('[data-fw-qty]').forEach(function (group) {
      var input = $('input', group);
      $$('button', group).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var step = btn.dataset.fwStep === 'down' ? -1 : 1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initVariants() {
    var form = $('[data-fw-product-form]');
    if (!form) return;
    var select = $('[name="id"]', form);
    $$('[data-fw-variant]', form).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        $$('[data-fw-variant]', form).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        select.value = btn.dataset.fwVariant;
        var price = $('[data-fw-price]');
        if (price && btn.dataset.fwPrice) price.textContent = btn.dataset.fwPrice;
        var sub = $('[data-fw-submit]', form);
        if (sub) {
          var sold = btn.dataset.fwAvailable === 'false';
          sub.disabled = sold;
          sub.textContent = sold ? (S.soldOutLabel || 'The field is empty') : (sub.dataset.fwLabel || 'Add to bag');
        }
      });
    });
  }

  /* ------------------------------------------------------------ cart drawer */
  var Cart = {
    init: function () {
      var drawer = $('[data-fw-cart]');
      if (!drawer) return;
      if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
      Cart.el = drawer;
      var goAt = function (e) {
        if (!drawer.classList.contains('is-open')) return null;
        var hit = null;
        drawer.querySelectorAll('.fw-drawer__go').forEach(function (b) {
          var rc = b.getBoundingClientRect();
          if (e.clientX >= rc.left && e.clientX <= rc.right && e.clientY >= rc.top && e.clientY <= rc.bottom) hit = b;
        });
        return hit;
      };
      window.addEventListener('click', function (e) {
        var go = goAt(e); if (!go) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (go.getAttribute('aria-disabled') === 'true') return;
        window.location.href = go.getAttribute('href');
      }, true);

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-fw-cart-open]')) { e.preventDefault(); Cart.open(); }
        if (e.target.closest('[data-fw-cart-close]') || e.target.matches('.fw-overlay__veil')) Cart.close();
        var rm = e.target.closest('[data-fw-cart-remove]');
        if (rm) { e.preventDefault(); Cart.change(rm.dataset.fwCartRemove, 0); }
        var st = e.target.closest('[data-fw-cart-step]');
        if (st) {
          e.preventDefault();
          Cart.change(st.dataset.fwKey, Math.max(0, parseInt(st.dataset.fwQty, 10) + (st.dataset.fwCartStep === 'down' ? -1 : 1)));
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

      /* AJAX add-to-cart on any FW product form */
      if (!window.__fwAddBound) {
        window.__fwAddBound = true;
        document.addEventListener('submit', function (e) {
          var form = e.target;
          if (!form || form.tagName !== 'FORM') return;
          var act = (form.getAttribute('action') || '');
          if (act.indexOf('/cart/add') === -1 && !form.hasAttribute('data-fw-product-form')) return;
          e.preventDefault(); e.stopImmediatePropagation();
          if (form._fwBusy) return; form._fwBusy = true;
          var btn = e.submitter || form.querySelector('[type="submit"]');
          if (btn) btn.classList.add('is-adding');
          var data = new FormData(form);
          fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              form._fwBusy = false; if (btn) btn.classList.remove('is-adding');
              if (!res.ok) { alert((res.j && (res.j.description || res.j.message)) || 'That one could not be added.'); return; }
              Cart.justAdded = res.j && (res.j.product_title || res.j.title);
              try { Cart.open(); } catch (err) {}
            }, function () { form._fwBusy = false; if (btn) btn.classList.remove('is-adding'); try { Cart.open(); } catch (err) {} });
        }, true);
      }
    },
    open:  function () { if (!Cart.el) return; Cart.el.classList.add('is-open');
                         var note = Cart.el.querySelector('[data-fw-added]');
                         if (note) { if (Cart.justAdded) { note.textContent = '\u2726 ' + Cart.justAdded + ' is tucked in your bag'; note.hidden = false; clearTimeout(Cart._nt); Cart._nt = setTimeout(function(){ note.hidden = true; }, 4200); } else note.hidden = true; }
                         Cart.justAdded = null; document.body.style.overflow = 'hidden'; document.documentElement.classList.add('fw-cart-open'); Cart.refresh();
                         var pill = $('[data-fw-pill]'); if (pill) pill.classList.remove('is-open'); },
    close: function () { Cart.el.classList.remove('is-open'); document.body.style.overflow = ''; document.documentElement.classList.remove('fw-cart-open'); },
    change: function (key, qty) {
      fetch((S.routes && S.routes.cartChange) || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { return Cart.refresh(); });
    },
    refresh: function () {
      return fetch('/cart?view=fw-drawer', { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-fw-cart-contents]');
          var target = $('[data-fw-cart-contents]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
          var count = doc.querySelector('[data-fw-cart-count]');
          $$('[data-fw-cart-count]').forEach(function (el) { if (count) el.textContent = count.textContent; });
          Cart.sync(doc);
        }).catch(function () {});
    },
    sync: function (doc) {
      doc = doc || document;
      var sub = doc.querySelector('[data-fw-cart-subtotal-src]'), ship = doc.querySelector('[data-fw-cart-ship-src]');
      var count = doc.querySelector('[data-fw-cart-count]');
      $$('[data-fw-cart-subtotal]').forEach(function (el) { if (sub) el.textContent = sub.textContent; });
      $$('[data-fw-cart-ship]').forEach(function (el) { if (ship) el.innerHTML = ship.innerHTML; });
      $$('[data-fw-cart-checkout]').forEach(function (el) { if (count) { if ((parseInt(count.textContent, 10) || 0) === 0) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled'); } });
    }
  };

  /* ---------------------------------------------------------------- popup */
  function initPopup() {
    var popup = $('[data-fw-popup]');
    var pill  = $('[data-fw-pill]');
    if (!popup) return;
    var KEY = 'fw-gift-claimed';
    var claimed = false;
    try { claimed = localStorage.getItem(KEY) === '1'; } catch (err) {}
    if (claimed) return;

    /* no artwork chosen for the popup? borrow whatever the hero is showing */
    var matchHero = function () {
      var slot = $('.fw-popup__art', popup);
      if (!slot || slot.dataset.fwOwnArt === 'true') return;
      var heroImg = $('[data-fw-hero-img]') || $('.fw-hero__img') || $('.fw-hero__frame img');
      if (heroImg && (heroImg.currentSrc || heroImg.src)) {
        slot.style.backgroundImage = 'url(' + (heroImg.currentSrc || heroImg.src) + ')';
        slot.style.backgroundSize = 'cover';
        slot.style.backgroundPosition = 'center';
      }
    };
    /* live at the top of <body> so no theme wrapper can clip or bury it */
    if (popup.parentNode !== document.body) document.body.appendChild(popup);
    var open  = function () {
      matchHero(); popup.classList.add('is-open'); popup.style.setProperty('display', 'flex', 'important');
      pill = pill || $('[data-fw-pill]'); if (pill) pill.classList.remove('is-open');
    };
    var close = function () {
      popup.classList.remove('is-open'); popup.style.setProperty('display', 'none', 'important');
      pill = pill || $('[data-fw-pill]'); if (pill) pill.classList.add('is-open');
      try { sessionStorage.setItem('fw-gift-seen', '1'); } catch (err) {}
    };
    window.FWGift = { open: open, close: close };

    /* auto-open once per visit (home page by default); after that the pill waits on every page */
    var SEEN = 'fw-gift-seen';
    var seen = false; try { seen = sessionStorage.getItem(SEEN) === '1'; } catch (err) {}
    if (popup.dataset.fwAuto !== 'false' && !seen) {
      var delay = (parseFloat(S.popupDelay) || 4) * 1000;
      setTimeout(function () {
        if (!$('.fw-overlay.is-open') && !$('.fw-lightbox.is-open')) open();
      }, delay);
    } else if (pill) pill.classList.add('is-open');

    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('[data-fw-popup-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(); });

    var form = $('form', popup);
    if (form) form.addEventListener('submit', function () {
      try { localStorage.setItem(KEY, '1'); } catch (err) {}
      if (pill) pill.remove();
    });

    /* Shopify renders ?customer_posted=true after a successful signup */
    if (/customer_posted=true/.test(location.search)) {
      try { localStorage.setItem(KEY, '1'); } catch (err) {}
      var done = $('[data-fw-popup-success]', popup);
      if (done) { done.hidden = false; open(); var f = $('[data-fw-popup-fields]', popup); if (f) f.hidden = true; }
    }
  }

  /* ------------------------------------------------ zodiac promo popup */
  function initZodiacPopup() {
    var pop = $('[data-fw-zpopup]');
    var pill = $('[data-fw-zpill]');
    if (!pop) return;
    var SEEN = 'fw-zodiac-seen';
    var art = $('[data-fw-zart]', pop), name = $('[data-fw-zname]', pop);
    $$('[data-fw-zchip]', pop).forEach(function (btn) {
      var pick = function () {
        $$('[data-fw-zchip]', pop).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (art) art.style.backgroundImage = 'url(' + btn.dataset.fwZchip + ')';
        if (name) name.textContent = btn.getAttribute('aria-label');
        var dot = pill && $('.fw-pill__art', pill); if (dot) dot.style.backgroundImage = 'url(' + btn.dataset.fwZchip + ')';
      };
      btn.addEventListener('mouseenter', pick); btn.addEventListener('click', pick);
    });
    var open = function () { pop.classList.add('is-open'); if (pill) pill.classList.remove('is-open'); };
    var close = function () { pop.classList.remove('is-open'); if (pill) pill.classList.add('is-open'); };
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-fw-zclose]')) close(); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-fw-zpill]')) { e.preventDefault(); open(); } });
    /* theme editor: open while the section is selected, close when deselected */
    if (pop.dataset.fwZdesign === 'true') {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && pop.dataset.fwZsection === e.detail.sectionId) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && pop.dataset.fwZsection === e.detail.sectionId) close(); });
      if (pill) pill.classList.add('is-open');
      return;
    }
    /* ?fw-promo in the URL always opens it — handy for testing */
    if (/[?&]fw-promo/.test(location.search)) { setTimeout(open, 600); return; }
    var seen = false;
    try { var t = parseInt(localStorage.getItem(SEEN) || '0', 10); seen = t && (Date.now() - t) < 12 * 3600 * 1000; } catch (e) {}
    if (seen) { if (pill) pill.classList.add('is-open'); return; }
    var tries = 0;
    var attempt = function () {
      var busy = $('.fw-popup.is-open') || $('.fw-overlay.is-open') || $('.fw-lightbox.is-open');
      if (busy && tries++ < 12) return setTimeout(attempt, 5000);
      try { localStorage.setItem(SEEN, String(Date.now())); } catch (e) {}
      open();
    };
    setTimeout(attempt, (parseFloat(S.zodiacDelay) || 16) * 1000);
  }

  /* -------------------------------------------------------- hero randomiser */
  function initHero() {
    var hero = $('[data-fw-hero-pool]');
    if (!hero) return;
    var pool;
    try { pool = JSON.parse(hero.getAttribute('data-fw-hero-pool')); } catch (err) { return; }
    if (!pool || pool.length < 2) return;
    var pick = pool[Math.floor(Math.random() * pool.length)];
    var img = $('[data-fw-hero-img]', hero);
    var tag = $('[data-fw-hero-tag]', hero);
    var link = $('[data-fw-hero-link]', hero);
    if (img) { img.src = pick.image; img.srcset = ''; img.alt = pick.alt || pick.title; }
    if (tag) tag.textContent = String(pick.caption || pick.title).replace(/\s*·\s*$/, '');
    if (link) link.setAttribute('href', pick.url);
  }

  /* ------------------------------------------------------------------ boot */
  /* ------------------------------------------------ star route window/plans */
  function initRoute() {
    var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'long', day: 'numeric' }); };
    $$('[data-fw-route]').forEach(function (el) {
      if (el._fwTimer) clearInterval(el._fwTimer);
      var months = (el.dataset.fwMonths || '2,5,8,11').split(',').map(function (n) { return parseInt(n, 10) - 1; })
        .filter(function (n) { return n >= 0 && n < 12; }).sort(function (a, b) { return a - b; });
      if (!months.length) return;
      var tick = function () {
        var now = new Date(), y = now.getFullYear(), m = now.getMonth(), open = months.indexOf(m) > -1, target, ship;
        if (open) { target = new Date(y, m + 1, 1); ship = target; }
        else {
          var next = months.filter(function (k) { return k > m; })[0];
          if (next === undefined) { next = months[0]; y += 1; }
          target = new Date(y, next, 1); ship = new Date(y, next + 1, 1);
        }
        var left = Math.max(0, target - now);
        var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, mi = Math.floor(left / 6e4) % 60;
        el.classList.toggle('is-open', open);
        $('[data-fw-route-label]', el).textContent = open ? 'Orders close in' : 'Orders open in';
        $('[data-fw-route-d]', el).textContent = d;
        $('[data-fw-route-h]', el).textContent = h;
        $('[data-fw-route-m]', el).textContent = mi;
        $('[data-fw-route-ship]', el).textContent = open
          ? 'Board now and your envelope ships ' + fmt(ship) + '.'
          : 'Board any time — your first envelope ships ' + fmt(ship) + '.';
      };
      tick(); el._fwTimer = setInterval(tick, 30000);
    });
  }

  function initStops() {
    var ord = function (n) { var t = n % 100; return n + ((t >= 11 && t <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th')); };
    var roman = function (n) { return ['i','ii','iii','iv','v','vi','vii','viii','ix','x','xi','xii'][n - 1] || String(n); };
    $$('[data-fw-stops]').forEach(function (grid) {
      var names = [];
      var data = $('[data-fw-editions]', grid.parentNode);
      try { names = JSON.parse(data ? data.textContent : '[]'); } catch (e) {}
      var p = (grid.dataset.fwFirst || '2026-12-01').split('-');
      var fy = +p[0], fm = (+p[1] || 12) - 1;
      var now = new Date(), k = 0;
      while (new Date(fy, fm + k * 3, 1) <= now) k++;
      $$('.fw-stop', grid).forEach(function (card, i) {
        var e = k + i, d = new Date(fy, fm + e * 3, 1), o = new Date(fy, fm + e * 3 - 1, 1);
        var title = names[e] && names[e].title;
        $('[data-fw-stop-roman]', card).textContent = roman(e + 1);
        $('[data-fw-stop-date]', card).textContent = d.toLocaleDateString('en-US', { month: 'short' }) + ' 1';
        $('[data-fw-stop-ed]', card).textContent = ord(e + 1) + ' Edition';
        $('[data-fw-stop-title]', card).textContent = title || 'yet to be drawn\u2026';
        $('[data-fw-stop-orders]', card).textContent = 'orders open ' + o.toLocaleDateString('en-US', { month: 'long' });
      });
    });
  }

  function initPlans() {
    $$('[data-fw-plans]').forEach(function (group) {
      var form = group.closest('form'); if (!form) return;
      var id = $('[name="id"]', form), sp = $('[name="selling_plan"]', form);
      var scope = form.closest('section') || document;
      group.addEventListener('click', function (e) {
        var card = e.target.closest('[data-fw-plan-variant]'); if (!card) return;
        e.preventDefault();
        $$('[data-fw-plan-variant]', group).forEach(function (b) { b.setAttribute('aria-checked', b === card ? 'true' : 'false'); });
        id.value = card.dataset.fwPlanVariant;
        if (sp) { sp.value = card.dataset.fwPlanSelling || ''; sp.disabled = !card.dataset.fwPlanSelling; }
        var price = $('[data-fw-plan-price]', scope), unit = $('[data-fw-plan-unit]', scope);
        if (price) price.textContent = card.dataset.fwPlanPrice;
        if (unit) unit.textContent = card.dataset.fwPlanUnit;
        var sub = $('[data-fw-submit]', form);
        if (sub) sub.disabled = card.dataset.fwAvailable === 'false';
      });
    });
  }

  /* ------------------------------------------------ one clean ground */
  function initGround() {
    var atm = $('.fw-atmosphere'); if (!atm) return;
    if (atm.parentNode !== document.body || document.body.firstElementChild !== atm) document.body.insertBefore(atm, document.body.firstChild);
    var vw = window.innerWidth, vh = window.innerHeight;
    var interactive = 'a,button,input,select,textarea,form,[role="dialog"],[role="button"]';
    // Atelier's decorative backdrop: big fixed/absolute layers with no controls in them
    $$('body *').forEach(function (el) {
      if (el === atm || el.closest('.fw') || el.closest('.fw-atmosphere')) return;
      if (/^(SCRIPT|STYLE|LINK|META|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'absolute') return;
      var r = el.getBoundingClientRect();
      if (r.width < vw * 0.8 || r.height < vh * 0.6) return;
      if (el.querySelector(interactive) || el.matches(interactive)) return;
      if ((el.textContent || '').trim().length > 0) return;
      el.classList.add('fw-atelier-backdrop-off');
    });
    // and any background painted on the wrappers around FW sections
    $$('.fw-section').forEach(function (sec) {
      for (var p = sec.parentElement; p && p !== document.documentElement; p = p.parentElement) {
        var bg = getComputedStyle(p).backgroundImage;
        if (bg && bg !== 'none') p.style.setProperty('background-image', 'none', 'important');
        var c = getComputedStyle(p).backgroundColor;
        if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') p.style.setProperty('background-color', 'transparent', 'important');
      }
    });
  }

  /* ------------------------------------------------ star route popup */
  function initStarRoutePopup() {
    var pop = $('[data-fw-srpopup]'); if (!pop) return;
    var pill = $('[data-fw-srpill]');
    var SEEN = 'fw-starroute-seen-v2';
    var open = function () { pop.classList.add('is-open'); if (pill) pill.classList.remove('is-open'); };
    var close = function () { pop.classList.remove('is-open'); if (pill) pill.classList.add('is-open'); };
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-fw-srclose]')) close(); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-fw-srpill]')) { e.preventDefault(); open(); } });
    if (pop.dataset.fwSrdesign === 'true') {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === pop.dataset.fwSrsection) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === pop.dataset.fwSrsection) close(); });
      if (pill) pill.classList.add('is-open');
      return;
    }
    if (/[?&]fw-starroute/.test(location.search)) { setTimeout(open, 600); return; }
    var seen = false;
    try { var t = parseInt(localStorage.getItem(SEEN) || '0', 10); seen = t && (Date.now() - t) < 24 * 3600 * 1000; } catch (e) {}
    if (seen) { if (pill) pill.classList.add('is-open'); return; }
    var tries = 0;
    var attempt = function () {
      var busy = $('.fw-popup.is-open') || $('.fw-zpopup.is-open') || $('.fw-overlay.is-open') || $('.fw-lightbox.is-open');
      if (busy && tries++ < 12) return setTimeout(attempt, 6000);
      try { localStorage.setItem(SEEN, String(Date.now())); } catch (e) {}
      open();
    };
    setTimeout(attempt, (parseInt(pop.dataset.fwSrdelay, 10) || 35) * 1000);
  }

  /* one shared pill stack — each popup section renders its own; merge them */
  /* Header pins to the top once scrolled past. Works even when the theme scrolls an
     inner wrapper instead of the window (which is what breaks CSS sticky). */
  function initStickyHeader() {
    var hd = $('.fw-header'); if (!hd || hd.dataset.fwPin) return;
    hd.dataset.fwPin = '1';
    var mark = document.createElement('div');
    mark.setAttribute('aria-hidden', 'true');
    mark.style.cssText = 'height:0;margin:0;padding:0;';
    hd.parentNode.insertBefore(mark, hd);
    var pinned = false, ticking = false;
    var check = function () {
      ticking = false;
      var past = mark.getBoundingClientRect().top < 0;
      if (past === pinned) return;
      pinned = past;
      if (pinned) { mark.style.height = hd.offsetHeight + 'px'; hd.classList.add('fw-header--pinned'); }
      else { hd.classList.remove('fw-header--pinned'); mark.style.height = '0px'; }
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }
  /* Judge.me → taped notes. Watches the hidden app block, copies each review into a note card. */
  function initKindWords() {
    $$('[data-fw-kind-notes]').forEach(function (grid) {
      var src = grid.parentNode.querySelector('[data-fw-kind-source]');
      if (!src || !src.children.length) return;
      var max = parseInt(grid.dataset.fwMax, 10) || 3;
      var minStars = parseInt(grid.dataset.fwMinStars, 10) || 1;
      var replace = grid.dataset.fwReplace !== 'false';
      var done = false;
      var rots = ['-0.7deg', '0.7deg', '-0.4deg', '0.6deg'], sways = ['2.7s', '3s', '3.3s', '2.9s'];
      var txt = function (el, sels) { for (var i = 0; i < sels.length; i++) { var n = el.querySelector(sels[i]); if (n && n.textContent.trim()) return n.textContent.trim(); } return ''; };
      var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
      var harvest = function () {
        if (done) return;
        var items = src.querySelectorAll('.jdgm-carousel-item, .jdgm-rev, .jdgm-all-reviews-text__review, [data-review-id], [class*="jdgm"][class*="__item"], [class*="jdgm"][class*="-card"]:not([class*="__"]), [class*="jdgm"][class*="slide"]:not([class*="slider"]):not([class*="__"]), [class*="testimonial"][class*="item"], [class*="review-card"]');
        var seen = {}, reviews = [];
        Array.prototype.forEach.call(items, function (it) {
          if (it.parentNode && it.parentNode.closest && it.parentNode.closest('.jdgm-rev, .jdgm-carousel-item') && !it.matches('.jdgm-carousel-item, .jdgm-rev')) return;
          var body = txt(it, ['.jdgm-carousel-item__review-body', '.jdgm-rev__body', '.jdgm-carousel-item__review', '.jdgm-all-reviews-text__body', '[class*="body"]', '[class*="content"] p', '[class*="quote"]', '[class*="text"]:not([class*="author"]):not([class*="name"])', 'p']);
          if (body.length < 8) return;
          if (!body || seen[body]) return; seen[body] = 1;
          var name = txt(it, ['.jdgm-carousel-item__reviewer-name', '.jdgm-rev__author', '.jdgm-all-reviews-text__author', '[class*="author"]', '[class*="reviewer"]', '[class*="name"]:not([class*="product"])']) || 'A dreamer';
          if (name.length > 40) name = name.slice(0, 40);
          var scoreEl = it.querySelector('[data-score]');
          var score = scoreEl ? parseFloat(scoreEl.getAttribute('data-score')) : it.querySelectorAll('.jdgm-star.jdgm--on, [class*="star"][class*="full"], [class*="star"][class*="--on"]').length;
          score = Math.round(score || 5);
          if (score < minStars) return;
          var verified = !!it.querySelector('.jdgm-rev__buyer-badge, .jdgm-carousel-item__verified, [class*="verified"]');
          var pLink = it.querySelector('a.jdgm-carousel-item__product, .jdgm-rev__prod-link, a[href*="/products/"]');
          reviews.push({ name: name, body: body, score: score, verified: verified,
            pTitle: pLink ? (txt(it, ['.jdgm-carousel-item__product-title', '.jdgm-rev__prod-link']) || pLink.textContent.trim()) : '',
            pUrl: pLink ? pLink.getAttribute('href') : '' });
        });
        if (!reviews.length) return;
        done = true;
        if (grid.dataset.fwShuffle !== 'false') {
          for (var k = reviews.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var t = reviews[k]; reviews[k] = reviews[j]; reviews[j] = t; }
        }
        if (replace) $$(':scope > *', grid).forEach(function (n) { n.style.display = 'none'; });
        reviews.slice(0, max).forEach(function (r, i) {
          var hearts = ''; for (var h = 1; h <= 5; h++) hearts += h <= r.score ? '\u2665' : '\u2661';
          var note = document.createElement('div');
          note.className = 'fw-note is-jdgm';
          note.style.animationDelay = (i * 80) + 'ms';
          note.innerHTML = '<span class="fw-note__tape" aria-hidden="true"></span>' +
            '<div class="fw-note__card" style="--fw-rot:' + rots[i % 4] + ';--fw-sway:' + sways[i % 4] + ';">' +
            '<i aria-hidden="true">\u2726</i><i aria-hidden="true">\u2726</i>' +
            '<div style="display:flex;align-items:center;gap:7px;margin-bottom:16px;"><span class="fw-note__name">' + esc(r.name) + '</span><span aria-hidden="true" style="font-size:12px;color:var(--fw-lime-ink);">\u2726</span></div>' +
            '<div class="fw-note__lines"><p>' + esc(r.body.length > 260 ? r.body.slice(0, 257).replace(/\s+\S*$/, '') + '\u2026' : r.body) + '</p></div>' +
            '<div class="fw-note__foot"><span>' + (r.verified ? 'verified buyer' : 'a kind soul') + '</span>' +
            '<span class="fw-hearts" aria-label="' + r.score + ' out of 5">' + hearts + '</span></div>' +
            (r.pTitle ? '<a class="fw-note__product" href="' + esc(r.pUrl) + '">\u2726 on ' + esc(r.pTitle) + '</a>' : '') + '</div>';
          grid.appendChild(note);
        });
        mo.disconnect();
      };
      var mo = new MutationObserver(harvest);
      mo.observe(src, { childList: true, subtree: true });
      harvest();
      /* if Judge.me never yields readable reviews, show its own widget (styled) instead of nothing */
      setTimeout(function () { if (!done && src.querySelector('.jdgm-widget, [class*="jdgm"]')) src.classList.add('is-fallback', 'fw-jdgm'); }, 8000);
    });
  }
  /* scrollbar: injected last in <head> so no theme stylesheet loaded after ours can override it */
  function initScrollbar() {
    if (document.getElementById('fw-scrollbar')) return;
    var st = document.createElement('style');
    st.id = 'fw-scrollbar';
    st.textContent =
      'html,body,*{scrollbar-color:#E6C7D3 #F3F5E7 !important}' +
      '@supports not (scrollbar-color: red blue){' +
      '::-webkit-scrollbar{width:10px!important;height:10px!important}' +
      '::-webkit-scrollbar-track{background:#F3F5E7!important}' +
      '::-webkit-scrollbar-thumb{background:linear-gradient(180deg,#FFC2DC,#E6C7D3)!important;border-radius:999px!important;border:2px solid #F3F5E7!important}}';
    document.head.appendChild(st);
  }
  function mergePillStacks() {
    var stacks = $$('.fw-pill-stack'); if (!stacks.length) return;
    var main = stacks[0];
    main.classList.add('fw-pill-stack--merged');
    if (main.parentNode !== document.body) document.body.appendChild(main);
    stacks.slice(1).forEach(function (s) { while (s.firstChild) main.appendChild(s.firstChild); s.remove(); });
    var gift = $('[data-fw-pill]', main); if (gift) main.appendChild(gift);
  }

  /* v5 — phone & tablet: menu sheet, sound toggle, drag-to-scroll rows, sticky add-to-bag */
  function initMobileMenu() {
    var sheet = document.querySelector('[data-fw-mobmenu]');
    if (!sheet || sheet._fw) return; sheet._fw = true;
    var opener = document.querySelector('[data-fw-menu-open]');
    var open = function () { sheet.hidden = false; document.documentElement.classList.add('fw-menu-open'); if (opener) opener.setAttribute('aria-expanded', 'true'); };
    var close = function () { sheet.hidden = true; document.documentElement.classList.remove('fw-menu-open'); if (opener) opener.setAttribute('aria-expanded', 'false'); };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-fw-menu-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-fw-menu-close]')) close();
      else if (!sheet.hidden && e.target.closest('[data-fw-mobmenu] a')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 1023 && !sheet.hidden) close(); });
  }

  function initSound() {
    var btns = document.querySelectorAll('[data-fw-sound]');
    var muted = false; try { muted = localStorage.getItem('fw-sound') === 'off'; } catch (e) {}
    var paint = function () {
      window.__fwMuted = muted;
      btns.forEach(function (b) { b.classList.toggle('is-muted', muted); b.setAttribute('aria-pressed', String(!muted)); var l = muted ? 'Sound off — click to unmute' : 'Sound on — click to mute'; b.setAttribute('aria-label', l); b.title = l; });
    };
    btns.forEach(function (b) { if (b._fw) return; b._fw = true; b.addEventListener('click', function () { muted = !muted; try { localStorage.setItem('fw-sound', muted ? 'off' : 'on'); } catch (e) {} paint(); if (!muted && Sparkle.play) try { Sparkle.play(); } catch (e) {} }); });
    paint();
  }

  function initDragScroll() {
    if (window.__fwDrag) return; window.__fwDrag = true;
    var SEL = '.fw-swipe,.fw-swipe-t,.fw-swipe-p,.fw-strip', drag = null;
    window.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var el = e.target.closest && e.target.closest(SEL);
      if (!el || el.scrollWidth <= el.clientWidth + 2) return;
      drag = { el: el, x: e.clientX, left: el.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; drag.el.classList.add('is-dragging'); }
      if (drag.moved) { drag.el.scrollLeft = drag.left - dx; e.preventDefault(); }
    }, { passive: false });
    var up = function () {
      if (!drag) return; var d = drag; drag = null; d.el.classList.remove('is-dragging');
      if (d.moved) { var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); }; window.addEventListener('click', stop, { capture: true, once: true }); setTimeout(function () { window.removeEventListener('click', stop, true); }, 0); }
    };
    window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
  }

  function initStickyBuy() {
    document.querySelectorAll('[data-fw-stickybuy]').forEach(function (bar) {
      if (bar._fw) return; bar._fw = true;
      var sec = bar.closest('.fw-section') || bar.parentNode;
      var real = sec.querySelector('[data-fw-submit]');
      var btn = bar.querySelector('[data-fw-stickybuy-btn]');
      if (!real) { bar.remove(); return; }
      btn.addEventListener('click', function () { real.click(); });
      document.documentElement.classList.add('fw-has-stickybuy');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { bar.classList.toggle('is-hidden', es[0].isIntersecting); }).observe(real);
      }
    });
  }


  function initReviewForm() {
    document.querySelectorAll('[data-fw-review]').forEach(function (box) {
      if (box._fw) return; box._fw = true;
      if (box.parentNode !== document.body) document.body.appendChild(box);
      var form = box.querySelector('[data-fw-review-form]');
      var err = box.querySelector('[data-fw-review-err]');
      var send = box.querySelector('[data-fw-review-send]');
      var step = function (n) { box.querySelectorAll('[data-fw-review-step]').forEach(function (s) { s.hidden = s.getAttribute('data-fw-review-step') !== n; }); };
      var open = function () { step('write'); err.hidden = true; box.hidden = false; document.documentElement.classList.add('fw-review-open'); setTimeout(function () { var t = form.querySelector('textarea'); if (t) t.focus(); }, 60); };
      var close = function () { box.hidden = true; document.documentElement.classList.remove('fw-review-open'); };
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-fw-review-open]')) { e.preventDefault(); open(); }
      });
      box.addEventListener('click', function (e) { if (e.target.closest('[data-fw-review-close]')) { e.preventDefault(); close(); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
      var fallback = function () {
        var link = document.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link');
        if (link) { close(); link.click(); var w = link.closest('.jdgm-widget') || link; window.scrollTo({ top: w.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' }); return true; }
        return false;
      };
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        var body = (fd.get('body') || '').toString().trim();
        if (body.length < 4) { err.textContent = 'A few more words, please ♥'; err.hidden = false; return; }
        err.hidden = true; send.disabled = true; send.classList.add('is-adding');
        var payload = {
          shop_domain: form.getAttribute('data-shop'), platform: 'shopify',
          id: Number(form.getAttribute('data-product')),
          name: (fd.get('name') || '').toString().trim(), email: (fd.get('email') || '').toString().trim(),
          rating: Number(fd.get('rating') || 5), title: (fd.get('title') || '').toString().trim(), body: body
        };
        var qs = new URLSearchParams();
        Object.keys(payload).forEach(function (k) { if (payload[k] !== '' && payload[k] != null && !(typeof payload[k] === 'number' && isNaN(payload[k]))) qs.append(k, payload[k]); });
        fetch('https://judge.me/api/v1/reviews', { method: 'POST', mode: 'no-cors', body: qs })
          .then(function (r) { if (r.type !== 'opaque' && !r.ok) throw new Error(r.status); return true; })
          .then(function () { send.disabled = false; send.classList.remove('is-adding'); form.reset(); step('done'); try { if (Sparkle.play) Sparkle.play(); } catch (x) {} })
          .catch(function () {
            send.disabled = false; send.classList.remove('is-adding');
            if (!fallback()) { err.textContent = 'Your note couldn’t be sent just now — please try again in a moment.'; err.hidden = false; }
          });
      });
    });
  }

  function initDesc() {
    document.querySelectorAll('[data-fw-desc]').forEach(function (box) {
      if (box._fw) return; box._fw = true;
      var btn = box.querySelector('[data-fw-desc-toggle]'), txt = box.querySelector('.fw-desc__text');
      if (!btn || !txt) return;
      if (txt.scrollHeight <= txt.clientHeight + 8) { box.classList.add('is-open'); btn.remove(); return; }
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.firstChild.textContent = open ? 'A little less' : 'Read the whole story';
      });
    });
  }

  function boot() {
    if (S.animations === false) document.documentElement.classList.add('fw-no-motion');
    /* each part runs on its own, so one failure can't stop the rest (sound, pills, hero) */
    [initMega, initGallery, initQty, initVariants, function () { Cart.init(); }, initPopup, initZodiacPopup, initGround, initStarRoutePopup, mergePillStacks, initStickyHeader, initKindWords, initScrollbar, initMobileMenu, initDesc, initReviewForm, initSound, initDragScroll, initStickyBuy, initHero, initRoute, initStops, initPlans, function () { Sparkle.init(); }]
      .forEach(function (fn) { try { fn(); } catch (err) { console.warn('[Finding Wonderland]', err); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* re-boot inside the theme editor when a section is re-rendered */
  document.addEventListener('shopify:section:load', boot);
})();
